import {ValueDefinition} from '@/model/types';

export enum FPGFeeType {
  RedemptionFees = 'DV-96#1',
  NoLoad = 'DV-96#2',
  FrontEndLoad = 'DV-96#3',
  AdvisorChargeback2Years = 'DV-96#4',
}

export const DV_96 = {
  id: 'DV-96',
  description: {
    fr: 'Type de frais',
    en: 'Fee type',
  },
  type: 'FeeType',
  values: [
    {
      id: '1',
      value: {fr: 'Frais au rachat', en: 'Redemption fees'},
      properties: {id_beneva: '0', DtDb: '2007-12-03', DtFi: '2199-12-31'},
    },
    {
      id: '2',
      value: {fr: 'Sans frais de souscription', en: 'No-load fees'},
      properties: {id_beneva: '1', DtDb: '2007-12-03', DtFi: '2199-12-31'},
    },
    {
      id: '3',
      value: {fr: "Frais à l'achat", en: 'Front end load'},
      properties: {id_beneva: '2', DtDb: '2007-12-03', DtFi: '2199-12-31'},
    },
    {
      id: '4',
      value: {fr: 'Récupération de commission - conseiller 2 ans', en: 'Advisor Chargeback'},
      properties: {id_beneva: '3', DtDb: '2007-12-03', DtFi: '2199-12-31'},
    },
  ],
} as const satisfies ValueDefinition;
